import roundMoney from './roundMoney.js'
import flatten from 'lowscore/flatten.js'

export default (priceBreakdown, insuranceName) => {
  let products = flatten(
    priceBreakdown.passengers.map(passenger => passenger.miscProducts.map(product => {
      product.attractsCommission = true
      return product
    }))
  )

  let aggregatedMiscellaneousProducts = []

  flatten(priceBreakdown.passengers.map(passenger => passenger.taxes))
    .forEach(tax => {
      if (tax) {
        products.push({
          productCode : "tax",
          productName : tax.name,
          totalPrice : tax.price,
          attractsCommission: false,
        })
      }
    })

  flatten(priceBreakdown.passengers.map(passenger => passenger.surcharges))
    .forEach(surcharge => {
      if (surcharge) {
        products.push({
          productCode: surcharge.surchargeTypeId,
          productName : surcharge.description,
          totalPrice : surcharge.amount,
          isSurcharge: true,
          attractsCommission: surcharge.isCommissionApplied,
        })
      }
    })

  flatten(priceBreakdown.passengers.map(passenger => passenger.travelProtectionPlan))
    .forEach(tp => {
      if (tp && tp.isMandatory) {
        products.push({
          productCode: tp.productCode,
          productName: insuranceName,
          totalPrice: tp.price,
          attractsCommission: true,
        })
      }
    })

  products
    .filter(product => product && product.productCode)
    .forEach(p => {
      let miscProduct = aggregatedMiscellaneousProducts.find(({productName}) => p.productName === productName)
      if (miscProduct) {
        miscProduct.totalPrice = roundMoney(miscProduct.totalPrice + p.totalPrice)
      } else {
        aggregatedMiscellaneousProducts.push({
          productName : p.productName,
          productCode : p.productCode,
          totalPrice : p.totalPrice,
          attractsCommission: p.attractsCommission,
          isSurcharge: p.isSurcharge,
          typeCode: p.typeCode,
          category: p.category,
          brochureCode: p.brochureCode,
        })
      }
    })

  let foodFunds = flatten(priceBreakdown.passengers.map(passenger => passenger.foodFunds))
    .reduce((total, amount) => total + amount, 0)

  if (foodFunds > 0) {
    aggregatedMiscellaneousProducts.push({
      productName : 'Food Funds',
      totalPrice : roundMoney(foodFunds),
      attractsCommission: false,
    })
  }

  return {aggregatedMiscellaneousProducts}
}
